module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNextPage,
      "clear": _vm.clear
    }
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.bookshelf), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item
      }
    })
  }), 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21feeba2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/bookshelf/index.vue
// module id = 311
// module chunks = 0